module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "copyrightpage"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('h3', {
    staticStyle: {
      "margin-top": "3em!important"
    },
    attrs: {
      "id": "anote"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo1.jpg"
    }
  })]), _c('a', {
    attrs: {
      "href": "#/text/05_toc#anote"
    }
  }, [_c('em', [_vm._v("Author’s note")])]), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1",
    staticStyle: {
      "margin-top": "2.5em!important",
      "font-size": "0.9em!important"
    }
  }, [_vm._v("In my previous book there was a final section of photographs of the finished model along with a separate colour section, either to view separately or refer to as reference whilst building a model. In this volume the photographs of the finished model have been dispersed throughout the text, as far as possible to illustrate areas of the model being covered at that point. They are easily distinguished from the text photographs by the linear border around them. A selection of further models, good examples of small craft, are displayed at the end of the book.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d3e7d4e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/05a_author.vue
// module id = 72
// module chunks = 0